/*
 * MUI `sx` objects used across AddVendorModal.
 * Kept in JS (not module.css) because they target MUI internal class names
 * like `.MuiSelect-select`, `.MuiChip-deleteIcon`, `.MuiFormControlLabel-label` etc.
 */

// Colors reused across MUI sx objects
const PRIMARY_RED = "#E42125";

//  Field styles (also consumed by CommonSelect/CommonFieldWrapper)

export const fieldWrapperSx = { minWidth: 0 };

export const fieldLabelStyle = {
  color: "#4A4A4A",
  fontSize: "1.25rem",
  fontWeight: 600,
  marginBottom: "0.55rem",
};

export const errorTextSx = {
  color: PRIMARY_RED,
  fontSize: "1.1rem",
  lineHeight: 1.35,
  mt: 0.5,
};

// Input

export const inputSx = {
  background: "#FFFFFF",
  border: "1px solid #E0E0E0",
  borderRadius: "6px",
  "& .MuiOutlinedInput-root": {
    minHeight: "4.2rem",
    paddingRight: "1rem",
  },
  input: {
    color: "#1F2933",
    fontSize: "1.35rem",
    padding: "1rem 1.2rem",
    "&::placeholder": {
      color: "#9A9A9A",
      fontSize: "1.35rem",
      opacity: 1,
    },
  },
};

// Same visual language as `locationSelectSx` -- used inside a service-location row.
export const locationInputSx = {
  background: "#EBEEF8",
  border: "1px solid #EBEEF8",
  borderRadius: "6px",
  "& .MuiOutlinedInput-root": {
    minHeight: "3.7rem",
    paddingRight: "1rem",
  },
  input: {
    color: "#5E6366",
    fontSize: "1.28rem",
    padding: "0.6rem 1rem",
    "&::placeholder": {
      color: "#9A9A9A",
      fontSize: "1.28rem",
      opacity: 1,
    },
  },
};

// Select
export const selectSx = {
  background: "#FFFFFF",
  border: "1px solid #E0E0E0",
  borderRadius: "6px",
  color: "#1F2933",
  fontSize: "1.35rem",
  height: "4.2rem",
  ".MuiSelect-select": {
    alignItems: "center",
    display: "flex",
    minHeight: "4.2rem",
    padding: "0 1.2rem",
  },
  "&.Mui-disabled": {
    background: "#F7F7F7",
  },
};

export const locationSelectSx = {
  ...selectSx,
  background: "#EBEEF8",
  border: "1px solid #EBEEF8",
  color: "#5E6366",
  height: "3.7rem",
  ".MuiSelect-select": {
    ...selectSx[".MuiSelect-select"],
    fontSize: "1.28rem",
    minHeight: "3.7rem",
    padding: "0 1rem",
  },
};

export const locationCitySelectSx = {
  ...locationSelectSx,
  background: "#FFFFFF",
  border: "1px solid #657BFF",
  height: "auto",
  minHeight: "3.7rem",
  ".MuiSelect-select": {
    ...locationSelectSx[".MuiSelect-select"],
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    py: "0.45rem",
  },
};

export const menuItemSx = { fontSize: "1.3rem" };
export const cityMenuItemSx = { fontSize: "1.25rem" };
export const optionTextProps = { fontSize: "1.3rem" };
export const cityOptionTextProps = { fontSize: "1.25rem" };

//Checkbox / Radio

export const redCheckboxSx = {
  color: PRIMARY_RED,
  "&.Mui-checked": { color: PRIMARY_RED },
};

export const radioSx = { color: PRIMARY_RED };

export const radioLabelSx = {
  ".MuiFormControlLabel-label": { fontSize: "1.3rem" },
};

export const specialisedRadioGroupSx = {
  alignItems: "center",
  gap: 1.5,
  minHeight: "4.2rem",
  px: 0,
};

// City chip

export const cityChipSx = {
  background: "#E8F3FF",
  borderRadius: "16px",
  color: "#333333",
  fontSize: "1.15rem",
  height: "2.4rem",
  ".MuiChip-deleteIcon": {
    color: PRIMARY_RED,
    fontSize: "1.5rem",
    marginRight: "0.5rem",
  },
};

// Buttons in service locations

export const addLocationBtnSx = {
  fontSize: "1.22rem",
  fontWeight: 500,
  height: "3.7rem",
  minWidth: "15rem",
  paddingX: "1.6rem",
};

export const removeLocationBtnSx = {
  fontSize: "1.15rem",
  height: "3.7rem",
  mt: { xs: 0, md: 0 },
  width: { xs: "100%", md: "10rem" },
};

//  Modal-level dynamic sx (based on step)

export const buildModalSx = (isLocationStep) => ({
  borderRadius: "8px",
  overflow: "hidden",
  px: { xs: 2, sm: isLocationStep ? 2.4 : 3 },
  pb: 0,
  pt: { xs: 1.8, sm: isLocationStep ? 2 : 2.5 },
});

export const buildStepContentSx = (isLocationStep) => ({
  py: isLocationStep ? 1.5 : 2,
});

//  Styles bundle passed to CommonSelect

export const buildSelectStylesBundle = ({
  selectStyleObj = selectSx,
  itemSx = menuItemSx,
  textProps = optionTextProps,
} = {}) => ({
  wrapperSx: fieldWrapperSx,
  labelStyle: fieldLabelStyle,
  selectSx: selectStyleObj,
  errorSx: errorTextSx,
  checkboxSx: redCheckboxSx,
  menuItemSx: itemSx,
  optionTextProps: textProps,
});
